import debounce from "./debounce";

const ANIMATION_DURATION = 300;
const ENABLED = "enabled";

export const enableAfterFirstAnimation = (selector) => {
  return debounce(() => {
    jQuery(selector).addClass(ENABLED);
  }, ANIMATION_DURATION)();
};
